<template>
<div class="monitor-container">
    <Row type="flex" :gutter="9">
        <Col flex="1" >
        <Card class="card-container" dis-hover>
            <!--信号交互-->
            <div slot="title" class="card-title">HRC501</div>
            <Row type="flex" class="normal-hover" >
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('p076') }}</div>
                    </Col>
                    <Col flex="1" >
                        <Input size="small" disabled/>
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row" >
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a196') }}</div>
                    </Col>
                    <Col flex="1" >
                        <Input size="small" disabled/>
                    </Col>
                </Row>
                </Col>
            </Row>                    
        </Card>
        </Col>

        <Col flex="1" >
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">{{ getTranslation('a197') }}</div>
            <Row type="flex" class="normal-hover">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a197') }}</div>
                    </Col>
                    <Col flex="1" >
                        <Input size="small" disabled/>
                    </Col>
                </Row>
                </Col>
            </Row>
            
        </Card>
        </Col>

    </Row>
   、
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex'
import { int16toBit, bitToInt16 } from '@/util/util'


export default {
    name: 'SystemInfo',
    components: {},
    props: {
        systemData: {
            type: Object,
            default: function() { return {} }
        },
        mac: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            // 需要按位编辑的字段列表，后续新增字段只需追加到此数组
            bitFields: [],
            // 原始值快照，保存时对比用
            originalData: {},
            // { HwAssy0: [0,1,0,...], HwAssy1: [...] }
            localBitsMap: {},
            // 需要本地副本的普通值字段（避免直接修改 prop），后续新增字段只需追加到此数组
            valueFields: [],
            // 本地值副本 { HwValveTypePrePrs: val, hwValveTypeTrip: val }
            localData: {}
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        
    },
    created() {
        var self = this
        this.bitFields.forEach(function(field) {
            self.$watch('systemData.' + field, function(newVal) {
                if (newVal != null) {
                    self.$set(self.localBitsMap, field, int16toBit(newVal))
                    self.$set(self.originalData, field, newVal)
                }
            }, { immediate: true })
        })
        this.valueFields.forEach(function(field) {
            self.$watch('systemData.' + field, function(newVal) {
                self.$set(self.localData, field, newVal)
                self.$set(self.originalData, field, newVal)
            }, { immediate: true })
        })
    },
    methods: {
        handleSave() {
            var payload = {}
            var self = this
            this.bitFields.forEach(function(field) {
                var bits = self.localBitsMap[field]
                if (!bits) return
                var newVal = bitToInt16(bits)
                if (newVal !== self.originalData[field]) {
                    payload[field] = newVal
                }
            })
            this.valueFields.forEach(function(field) {
                var newVal = self.localData[field]
                if (newVal != null && newVal !== self.originalData[field]) {
                    payload[field] = newVal
                }
            })
            if (Object.keys(payload).length > 0) {
                this.$emit('save', payload)
            }else {
                 this.$Message.error(this.getTranslation('a159'))
            }
        }
    },
}
</script>

<style scoped>
@import url('../../../../assets/style/list.css');
@import url('../../../../assets/style/tab.css');
.multi-row{
    margin-top:10px;
}

</style>
